import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Container, Row, Col, Button, Modal, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../components/auth/useAuth'
import { addBusiness, getBusinesses, editBusiness, addDocument, deleteDocument, enableBusiness, disableBusiness } from '../../../actions/businessesActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import BusinessForm from '../../../components/forms/BusinessForm'
import BusinessDocumentsForm from '../../../components/forms/BusinessDocumentsForm'

export default function Businesses({typeBusiness = 'provider'}) {
    const { t } = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const {businesses, resultbusiness, loading, total} = useSelector(state=>state.businesses)

    const [modalShow, setModalShow] = useState(false)
    const [modalShowDocument, setModalShowDocument] = useState(false)
    const [formState, setFormState] = useState({})
    const [formStateDocument, setFormStateDocument] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)
    const [filterActive, setFilterActive] = useState(true)

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [sortField, setSortField] = useState('identifier')
    const [sortOrder, setSortOrder] = useState('asc')

    useEffect(() => {
        if(clientauth){
            dispatch(getBusinesses(typeBusiness, page, limit, search, sortField, sortOrder, filterActive))
        }
    // eslint-disable-next-line
    }, [dispatch, clientauth, typeBusiness, page, limit, search, sortField, sortOrder, filterActive])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            identifier: '',
            name: '',
            companyName: '',
            contact: '',
            address: '',
            cp: '',
            location: '',
            province: '',
            phone: '',
            cif: '',
            others: '',
        })
        setModalShow(true)
    }

    const selectBusiness = (business) => {
        setIsAddingOrEditing('editing')
        setFormState(business)
        setModalShow(true)
    }
    const selectBusinessDocument = (business) => {
        setFormStateDocument({
            businessId: business._id,
            businessName: business.name,
            documentDescription: '',
            documentUrl: '',
            documents:business.documents
        })
        setModalShowDocument(true)
    }

    const handleSort = (column, sortDirection) => {
        setSortField(column.id || 'identifier')
        setSortOrder(sortDirection)
        setPage(1)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }
    const handleInputDocumentChange = ({target})=>{
        setFormStateDocument({
            ...formStateDocument,
            [target.name]: target.value
        })
    }
    const handleFileChange = ({target})=>{
        setFormStateDocument({
            ...formStateDocument,
            [target.name]: target.files[0]
        })
    }

    const handleCheckboxChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.checked
        })
    }

    const handleDeleteDocument = async(document, business) => {
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            denyButtonText: t('global.no'),
            icon: 'question',
            text:  t('admin.businesses.areyousuredeletedocument')
        }).then((resultuser) => {
            if (resultuser.isConfirmed) {
                dispatch(deleteDocument(document, business))
            }
        })
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editBusiness(formState, formState._id))
        }else{
            dispatch(addBusiness(formState,typeBusiness))
        }
        setIsRegistering(false)
    }

    const handleSubmitDocument= async(e) => {
        e.preventDefault()
        setIsRegistering(true)
        dispatch(addDocument(formStateDocument, formStateDocument.businessId))
        setIsRegistering(false)
    }

    const disableEnableBusinesses = async(e) => {
        e.preventDefault()
        let textQuestion = ''
        formState.active
            ?
                textQuestion = t('admin.businesses.areyousuredisable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'
            :
                textQuestion = t('admin.businesses.areyousureenable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'question',
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (formState.active) {
                    dispatch(disableBusiness(formState._id))
                }else{
                    dispatch(enableBusiness(formState._id))
                }
            }
        })
    }

    useEffect(() => {
        if(resultbusiness){
            let resultbusinessTemp = resultbusiness
            dispatch({ type: 'PROVIDER_RESET_RESULT'})
            switch (resultbusinessTemp) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successedit':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setModalShowDocument(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successDeleteDocument':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.deletesuccess')
                    }).then(() => {
                        setModalShowDocument(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successenable':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.enablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successdisable':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.businesses.disablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultbusiness])

    const columnsBusinesses = [
        {
            id: 'identifier',
            name: t('admin.businesses.identifier'),
            width: '110px',
            cell: business =>
                <div className='cursor' onClick={() => selectBusiness(business)}>
                    {business.identifier}
                </div>,
            selector: (business) => business.identifier,
            sortable: true,
        },{
            id: 'name',
            name: t('admin.businesses.name'),
            cell: business =>
                <div className='cursor' onClick={() => selectBusiness(business)}>
                    {business.name}
                </div>,
            selector: (business) => business.name,
            sortable: true,
        },{
            id: 'cif',
            name: t('admin.businesses.cif'),
            width: '120px',
            cell: business =>
                <div className='cursor' onClick={() => selectBusiness(business)}>
                    {business.cif}
                </div>,
            selector: (business) => business.cif,
            sortable: true,
        },{
            id: 'email',
            name: t('admin.businesses.email'),
            cell: business =>
                <div className='cursor' onClick={() => selectBusiness(business)}>
                    {business.email}
                </div>,
            selector: (business) => business.email,
            sortable: true,
        },{
            id: 'location',
            name: t('admin.businesses.location'),
            cell: business =>
                <div className='cursor' onClick={() => selectBusiness(business)}>
                    {business.location} {business.province ? <>({business.province})</> : ''}
                </div>,
            selector: (business) => business.location,
            sortable: true,
        },{
            id: 'phone',
            name: t('admin.businesses.phone'),
            width: '120px',
            cell: business =>
                <div className='cursor' onClick={() => selectBusiness(business)}>
                    {business.phone}
                </div>,
            selector: (business) => business.phone,
            sortable: true,
        },{
            id: 'active',
            name: t('admin.businesses.active'),
            width: '80px',
            cell: business =>
                <div>
                    {business.active
                        ?
                            <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                            <img src="../images/times.svg" alt="times" width={25}></img>
                    }
                </div>,
            selector: (business) => business.active,
            sortable: true,
        },{
            name: '',
            width: '100px',
            center: true,
            cell: business =>
                <>
                    <div className='cursor me-3' onClick={() => selectBusiness(business)}>
                        <i className='fas fa-pencil'></i>
                    </div>
                    <div className='cursor' onClick={() => selectBusinessDocument(business)}>
                        <i className='fas fa-paperclip'></i> {business.documents?.length > 0 ? business.documents.length : ''}
                    </div>
                </>,
            sortable: false,
        }
    ]
    const ExpandedRow = ({ data }) => {
        const fullAddress = [data?.address, data?.cp, data?.location, data?.province].filter(Boolean).join(', ')
        const Detail = ({ label, value }) => (
            <div className='d-flex justify-content-between border-bottom py-2'>
                <small className='text-muted'>{label}</small>
                <span className='text-end'>{(value === 0 || value) ? value : '—'}</span>
            </div>
        )
        return (
            <Container className='p-3'>
                <Row>
                    <Col xs={12} lg={6}>
                        <Detail label={t('admin.businesses.companyName')} value={data?.companyName} />
                        <Detail label={t('admin.businesses.contact')} value={data?.contact} />
                        <Detail label={t('admin.businesses.mainAddress')} value={fullAddress} />
                    </Col>
                    <Col xs={12} lg={6}>
                        <Detail label={t('admin.businesses.tabLocations')} value={data?.addresses?.length || 0} />
                        <Detail label={t('admin.businesses.documents')} value={data?.documents?.length || 0} />
                        <Detail label={t('admin.businesses.others')} value={data?.others} />
                    </Col>
                </Row>
            </Container>
        )
    }

    const filteredBusinesses = businesses

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col xs={12} className='text-center'>
                    <h1>
                        {t(`admin.businesses.${typeBusiness}`)}&nbsp;
                        {filterActive
                            ?
                            t('admin.businesses.businessesenabled')
                            :
                            t('admin.businesses.businessesdisabled')
                        }
                    </h1>
                </Col>
                <Col xs={6} className='d-flex justify-content-start'>
                    <ToggleButtonGroup
                        type="radio"
                        name="filterActive"
                        value={filterActive}
                        onChange={(value) => { setFilterActive(value); setPage(1) }}
                    >
                        <ToggleButton id="tbg-active" value={true} variant={filterActive === true ? "primary" : "outline-secondary"}>
                            {t('admin.businesses.enabled')}
                        </ToggleButton>
                        <ToggleButton id="tbg-inactive" value={false} variant={filterActive === false ? "primary" : "outline-secondary"}>
                            {t('admin.businesses.disabled')}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Col>
                <Col xs={6} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className='fas fa-plus'></i> {t('admin.businesses.createbusiness')}
                    </Button>
                </Col>
            </Row>
            {loading && !businesses ?
                <Loader/>
            :
                <Row>
                    <Col>
                        <div className="d-flex my-2">
                            <input
                                type="text"
                                className="sd-input form-control me-2"
                                placeholder={t("datatables.buscar")}
                                value={searchAux || ""}
                                onChange={e => {
                                    setSearchAux(e.target.value);
                                    setPage(1);
                                }}
                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                            />
                            <Button variant="primary" onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                        </div>
                        {filteredBusinesses?.length > 0 ?
                            <CustomDataTable
                                columns={columnsBusinesses}
                                data={filteredBusinesses}
                                expandedData={ExpandedRow}
                                pagination
                                paginationServer
                                paginationTotalRows={total}
                                paginationPerPage={limit}
                                progressPending={loading}
                                sortServer
                                onSort={handleSort}
                                defaultSortField={sortField}
                                defaultSortAsc={sortOrder !== 'desc'}
                                exportable={false}
                                printable={false}
                                onChangeRowsPerPage={(newLimit) => {
                                    setLimit(newLimit)
                                    setPage(1)
                                }}
                                onChangePage={(newPage) => {
                                    setPage(newPage)
                                }}
                            />
                        :
                            <h4 className='mt-4'>{t('admin.businesses.thereisnotbusinesses')}</h4>
                        }
                    </Col>
                </Row>
            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2 className='m-0'>{t(`admin.businesses.${typeBusiness}`)}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BusinessForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        handleCheckboxChange={handleCheckboxChange}
                        submit={handleSubmit}
                        disableEnableBusinesses={disableEnableBusinesses}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        typeBusiness={typeBusiness}
                    />
                </Modal.Body>
            </Modal>
            <Modal
                show={modalShowDocument}
                onHide={() => setModalShowDocument(false)}
                aria-labelledby="contained-modal-title-vcenter-clip"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter-clip">
                        <h2 className='m-0'>{formStateDocument?.businessName} - {t('admin.businesses.documents')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BusinessDocumentsForm
                        state={formStateDocument}
                        handleInputChange={handleInputDocumentChange}
                        handleFileChange={handleFileChange}
                        handleDeleteDocument={handleDeleteDocument}
                        submit={handleSubmitDocument}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}